// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604091508/js/" + chunkId + "." + {"44":"650c0fd8","225":"9d60f4a1","481":"6b43aad2","486":"52160f6d","770":"a93660b4"}[chunkId] + ".0.7427609015127072.chunk.js";
};